import api from './client';

export const getAdminNotifications = () =>
  api.get('/admin/notifications').then(r => r.data);

export const markNotificationRead = (id) =>
  api.post(`/admin/notifications/${id}/read`).then(r => r.data);

export const markAllNotificationsRead = () =>
  api.post('/admin/notifications/read-all').then(r => r.data);
